const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;

/**
 * @param {string} value
 * @param {{ required?: boolean }} [options]
 */
export function validateEmail(value, options = {}) {
  const { required = false } = options;
  const email = (value || "").trim();
  if (!email) {
    return required
      ? { valid: false, error: "Email is required" }
      : { valid: true };
  }
  if (!EMAIL_REGEX.test(email)) {
    return { valid: false, error: "Please enter a valid email address" };
  }
  return { valid: true };
}

/**
 * @param {string} value
 * @param {{ minLength?: number, maxLength?: number }} [options]
 */
export function validatePhoneNumber(value, options = {}) {
  const { minLength = 6, maxLength = 15 } = options;
  const phone = (value || "").trim();

  if (!phone) {
    return { valid: false, error: "Phone number is required" };
  }
  if (!/^\d+$/.test(phone)) {
    return { valid: false, error: "Phone number must contain digits only" };
  }
  if (phone.length < minLength) {
    return {
      valid: false,
      error: `Phone number must be at least ${minLength} digits`,
    };
  }
  if (phone.length > maxLength) {
    return {
      valid: false,
      error: `Phone number must be at most ${maxLength} digits`,
    };
  }
  return { valid: true };
}
